import {
	addGuestCreditCard,
	AddGuestCreditCardParams,
	CreditCard,
	CreditCardSchema,
} from "@/api/credit-cards/credit-cards";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { creditCardKeys } from "./keys";

export default function useAddCreditCard(
	guestId: number,
	options?: MutationOptionsWithoutFn<CreditCard, AddGuestCreditCardParams>,
) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: addGuestCreditCard,
		...options,
		onSuccess: (creditCard) => {
			const queryKey = creditCardKeys.list({ guestId });
			const creditCardValidation = CreditCardSchema.safeParse(creditCard);
			if (creditCardValidation.success) {
				queryClient.setQueryData(queryKey, (oldData: CreditCard[]) => {
					return [...oldData, creditCardValidation.data];
				});
			} else {
				queryClient.invalidateQueries({
					queryKey,
				});
			}

			options?.onSuccess;
		},
	});
}
